export default __webpack_public_path__ + "static/media/theCardGame2.c7e1b004.png";